import { Chakra } from "@airhelp/react-ui-components";
import type { CategoryListProps } from "./CategoryList.d";
import CategoryListItem from "../CategoryListItem";

const { Box } = Chakra;

const CategoryList = ({ categories }: CategoryListProps) => (
  <Box>
    {categories.map((category, index) => (
      <CategoryListItem key={category.id} category={category} isLast={index + 1 === categories.length} />
    ))}
  </Box>
);

export default CategoryList;
